import React from "react";
import { createRoot } from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import RouteConfig from "./route-config";
import { createBrowserHistory } from "history";
// import { Worker } from "@react-pdf-viewer/core";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./index.css";
import Header from "./Layout/Header";
import { createHttpClient, requestInterceptor } from "./core/httpClient";
import { APP_SETTINGS } from "./env";


import { Worker } from '@react-pdf-viewer/core';


const history = createBrowserHistory();

// const requestInterceptor = (config = {}) => {
//   config.headers = {};
//   const token = sessionStorage.getItem('token');
//   if (token) {
//     config.headers['x-access-token'] = token;
//     console.log("Token is-", token)
//   }
//   config.headers['Cache-Control'] = 'no-cache';
//   config.headers.Pragma = 'no-cache';
//   config.headers.Expires = '-1';
//   config.headers['Access-Control-Allow-Origin'] = '*';
//   return config;
// };

const currentDomain = window.location.hostname.split(".")[1];

let endpointToUse;

if (currentDomain === "azurewebsites") {
  endpointToUse = new URL(APP_SETTINGS.public_endpoint).origin;
} else {
  endpointToUse = new URL(APP_SETTINGS.private_endpoint).origin;
}

console.log("Endpoint to use:", endpointToUse);

export const servicesClient = createHttpClient(
  endpointToUse,
  requestInterceptor
);
servicesClient.defaults.headers.common["x-access-token"] =
  sessionStorage.getItem("token");

// Use createRoot instead of ReactDOM.render
createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Header></Header>
    <hr style={{}}></hr>
    <div className="container">
      <RouteConfig history={history} />
    </div>
    
    <Worker workerUrl="/pdf.worker.min.js">
      
    </Worker>
  </React.StrictMode>
);
reportWebVitals();



// import React from "react";
// import { createRoot } from "react-dom/client";
// import reportWebVitals from "./reportWebVitals";
// import RouteConfig from "./route-config";
// import { createBrowserHistory } from "history";
// import { Worker } from "@react-pdf-viewer/core";
// import "@react-pdf-viewer/core/lib/styles/index.css";
// import "@react-pdf-viewer/default-layout/lib/styles/index.css";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min";
// import "./index.css";
// import Header from "./Layout/Header";
// import { createHttpClient, requestInterceptor } from "./core/httpClient";
// import { APP_SETTINGS } from "./env";

// // Set up PDFJS worker
// import { pdfjs } from 'react-pdf';
// // Explicitly specify the worker
// pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js';

// const history = createBrowserHistory();

// const currentDomain = window.location.hostname.split(".")[1];

// let endpointToUse;

// if (currentDomain === "azurewebsites") {
//   endpointToUse = new URL(APP_SETTINGS.public_endpoint).origin;
// } else {
//   endpointToUse = new URL(APP_SETTINGS.public_endpoint).origin;
// }

// console.log("Endpoint to use:", endpointToUse);

// export const servicesClient = createHttpClient(
//   endpointToUse,
//   requestInterceptor
// );
// servicesClient.defaults.headers.common["x-access-token"] =
//   sessionStorage.getItem("token");

// // Use createRoot instead of ReactDOM.render
// createRoot(document.getElementById("root")).render(
//   <React.StrictMode>
//     <Worker workerUrl="/pdf.worker.min.js">
//       <Header />
//       <hr />
//       <div className="container">
//         <RouteConfig history={history} />
//       </div>
//     </Worker>
//   </React.StrictMode>
// );
// reportWebVitals();